export default function ContractsTableHeader({ showActions = true }){
    return(
        <div className="border-1 border-gray flex border-b px-0 py-2 text-left">
            <div className={`block font-bold w-[15%]`}>
                <h2 className="text-sm">File</h2>
            </div>
            <div className={`block font-bold w-[15%]`}>
                <h2 className="text-sm text-center">Contract Name</h2>
            </div>
            <div className={`block font-bold w-[15%]`}>
                <h2 className="text-sm text-center">Start Date</h2>
            </div>
            <div className={`block font-bold w-[15%]`}>
                <h2 className="text-sm text-center">Term Date</h2>
            </div>
            <div className={`block font-bold w-[15%]`}>
                <h2 className="text-sm text-center">EIN</h2>
            </div>
            <div className={`block font-bold w-[15%]`}>
                <h2 className="text-sm text-center">PIP State</h2>
            </div>
            {showActions && <div className="hidden w-[5%] font-bold md:block">&nbsp;</div>}
        </div>
    );
}
